function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import CheckUtils from '../../utilities/check-utils';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientServiceOrder = /*#__PURE__*/function () {
  function ApiClientServiceOrder(token) {
    _classCallCheck(this, ApiClientServiceOrder);
    this.token = token;
  }
  return _createClass(ApiClientServiceOrder, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * grab warranty details for the specified device
     *
     * @param serialNo {string}
     */
  }, {
    key: "getDetails",
    value: function getDetails(serialNo) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/service/device/".concat(serialNo), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          if (err.response.status === 404) {
            reject(err.response);
          } else {
            _this.errorHandlingCallback(err);
            reject(err);
          }
        });
      });
    }
  }, {
    key: "getDetailsFromCart",
    value: function getDetailsFromCart(serialNo, orderId) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/service/device/".concat(serialNo, "?orderId=").concat(orderId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this2.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          if (err.response.status === 404) {
            reject(err.response);
          } else {
            _this2.errorHandlingCallback(err);
            reject(err);
          }
        });
      });
    }

    /**
     * grab BillTo and SellTo for current user
     *
     * @returns {Promise<unknown>}
     */
  }, {
    key: "getAccountBillToRelation",
    value: function getAccountBillToRelation() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        axios.get('/api/billToRelation/getUserBillTo', AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getShippingInformation",
    value: function getShippingInformation(sellTo) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/customers/customerList/".concat(sellTo), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * retrieves all saved carts for the user.  returns null if none.
     * @returns {Promise<unknown>}
     */
  }, {
    key: "getServiceOrderDrafts",
    value: function getServiceOrderDrafts() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        axios.get('/api/shop/cart/saved-carts', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this5.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "continueServiceOrderDraft",
    value: function continueServiceOrderDraft(cartId, orderType) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/shop/cart/add-savedOrder-to-cart?orderId=".concat(cartId, "&orderType=").concat(orderType), '', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "removeServiceOrderDraft",
    value: function removeServiceOrderDraft(cartId, orderType) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/shop/cart/delete-saved-carts?cartId=".concat(cartId, "&orderType=").concat(orderType), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this7.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          reject(err);
        });
      });
    }

    /**
     * saves express exchange order
     *
     * @param expressExchangeOrder
     * @returns {Promise<unknown>}
     */
  }, {
    key: "addExpressExchangeToCart",
    value: function addExpressExchangeToCart(expressExchangeOrder) {
      var _this8 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/service/express-exchange-orders', expressExchangeOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this8.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this8.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * saves speaker replacement order
     *
     * @param speakerReplacementOrder
     * @returns {Promise<unknown>}
     */
  }, {
    key: "addSpeakerReplacementOrder",
    value: function addSpeakerReplacementOrder(speakerReplacementOrder) {
      var _this9 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/service/speaker-replacement-orders', speakerReplacementOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this9.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this9.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * saves express exchange order
     *
     * @param repairOrder
     * @returns {Promise<unknown>}
     */
  }, {
    key: "addRepairOrderToCart",
    value: function addRepairOrderToCart(repairOrder, orderId) {
      var _this0 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/service/repair-orders?orderId=".concat(orderId), repairOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this0.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this0.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "getShippingLabel",
    value: function getShippingLabel(data) {
      return new Promise(function (resolve, reject) {
        axios.post('/webservices/shipping.svc/getlabel', data).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    }

    /**
     * saves cart drafts order
     *
     * @returns {Promise<unknown>}
     */
  }, {
    key: "saveForLaterFromCart",
    value: function saveForLaterFromCart(orderId, typeOfService) {
      var _this1 = this;
      console.log(AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), this.token));
      return new Promise(function (resolve, reject) {
        axios.post("/api/shop/cart/save-draft?orderId=".concat(orderId, "&orderType=").concat(typeOfService), {}, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this1.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this1.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "addSecondEarExpressExchangeToCart",
    value: function addSecondEarExpressExchangeToCart(expressExchangeOrder, orderId) {
      var _this10 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/service/express-exchange-orders?orderId=".concat(orderId), expressExchangeOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this10.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this10.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "updateExpressExchangeInCart",
    value: function updateExpressExchangeInCart(updatedExpressExchangeOrder) {
      var _this11 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/service/express-exchange-orders/update', updatedExpressExchangeOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this11.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this11.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteExpressServiceOrders",
    value: function deleteExpressServiceOrders(id) {
      var _this12 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/express-exchange-orders/delete?expressExchangeId=".concat(id), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this12.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this12.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteExpressServiceEarOnly",
    value: function deleteExpressServiceEarOnly(id, serialNo) {
      var _this13 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/express-exchange-orders/delete?expressExchangeId=".concat(id, "&serialNo=").concat(serialNo), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this13.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this13.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteSpeakerReplacementServiceOrders",
    value: function deleteSpeakerReplacementServiceOrders(id) {
      var _this14 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/speaker-replacement-orders/delete?orderId=".concat(id), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this14.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this14.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteSpeakerReplacementSpeakerOnly",
    value: function deleteSpeakerReplacementSpeakerOnly(id, serialNo) {
      var _this15 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/speaker-replacement-orders/delete?orderId=".concat(id, "&serialNo=").concat(serialNo), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this15.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this15.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "updateSpeakerReplacementInCart",
    value: function updateSpeakerReplacementInCart(updatedSpeakerReplacementOrder) {
      var _this16 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/service/speaker-replacement-orders/update', updatedSpeakerReplacementOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this16.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this16.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "addAdditionalSpeakerToCart",
    value: function addAdditionalSpeakerToCart(speakerReplacementOrder, orderId) {
      var _this17 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/service/speaker-replacement-orders?orderId=".concat(orderId), speakerReplacementOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this17.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this17.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteRepairOrdersServiceOrders",
    value: function deleteRepairOrdersServiceOrders(id) {
      var _this18 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/repair-orders/delete?repairOrderId=".concat(id), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this18.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this18.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "deleteRepairOrderSerialOnly",
    value: function deleteRepairOrderSerialOnly(id, serialNo) {
      var _this19 = this;
      return new Promise(function (resolve, reject) {
        axios.delete("/api/service/repair-orders/delete?repairOrderId=".concat(id, "&serialNo=").concat(serialNo), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this19.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this19.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Retrieve a list of available symptom codes for repair orders
     *
     * @returns {Promise<unknown>}
     */
  }, {
    key: "getSymptomCodes",
    value: function getSymptomCodes() {
      var _this20 = this;
      return new Promise(function (resolve, reject) {
        axios.get('/api/service/repair-orders/get-symptoms', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this20.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this20.errorHandlingCallback(err.response.data);
        });
      });
    }
  }, {
    key: "getRepairProductInformation",
    value: function getRepairProductInformation(serialNumber, aidType) {
      var _this21 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/service/repair-orders/get-productInfo?serialNumber=".concat(serialNumber, "&aidType=").concat(aidType), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this21.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          _this21.errorHandlingCallback(err.toJSON());
          reject(err.toJSON());
        });
      });
    }
  }, {
    key: "updateRepairProductInformation",
    value: function updateRepairProductInformation(feature, salesItemNo) {
      var _this22 = this;
      return new Promise(function (resolve, reject) {
        axios.post("api/service/repair-orders/update-productInfo?itemNumber=".concat(salesItemNo), feature, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this22.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          _this22.errorHandlingCallback(err.toJSON());
          reject(err.toJSON());
        });
      });
    }

    /**
     * Updates impression images for a client order.
     * Creates the FormData object from the input files
     * @param {string} orderId
     * @param {File} leftFile
     * @param {File} rightFile
     */
  }, {
    key: "updateImpressionImages",
    value: function updateImpressionImages(orderId, orderType) {
      var _this23 = this;
      var leftFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var rightFile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var formData = new FormData();
      formData.append('leftFile', leftFile);
      formData.append('rightFile', rightFile);
      var promise = new Promise(function (resolve, reject) {
        axios.post("/api/shop/impression-file/".concat(orderId, "/").concat(orderType, "/upload-impression"), formData, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this23.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Deletes the left or right side impression image for a patient order
     * @param {string} orderId
     * @param {string} side
     * @param {string} orderType
     */
  }, {
    key: "deleteImpressionImage",
    value: function deleteImpressionImage(orderId, side, orderType) {
      var _this24 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete(// TODO update with new api endpoint when Mani has completed.
        "/api/shop/impression-file/".concat(orderId, "/").concat(orderType, "/impression-files/").concat(side), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this24.token)).then(function (response) {
          if (response.status === 200) {
            // Success
            resolve(response.data);
          } else {
            // HTTP Error
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // Connection error
          reject(err);
        });
      });
      return promise;
    }

    /**
     * Validates Otoscan packageID
     * @param orderId
     * @param packageId
     * @returns {Promise<unknown>}
     */
  }, {
    key: "validateOtoscanImpression",
    value: function validateOtoscanImpression(orderId, packageId, orderType) {
      var _this25 = this;
      return new Promise(function (resolve, reject) {
        axios.post('/api/shop/impression-file/package-data', {
          orderId: orderId,
          packageId: packageId,
          orderType: orderType
        }, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this25.token)).then(function (response) {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // connection error
          reject(err);
        });
      });
    }

    /**
     * Validates Impression on File for particular serial Number.
     * @param orderId
     * @param leftSerialNumber
     * @param rightSerialNumber
     * @param orderType
     * @returns {Promise<unknown>}
     *
     * TODO replace api url with correct once new api is build.  Expected response from the api is a true/false value the same as the api response for Otoscan package validation.
     */
  }, {
    key: "validateImpressionOnFile",
    value: function validateImpressionOnFile(orderId, leftSerialNumber, rightSerialNumber, orderType) {
      var _this26 = this;
      var payload = {
        orderId: orderId,
        orderType: orderType,
        serialData: []
      };
      if (!CheckUtils.isNullOrEmptyString(leftSerialNumber)) {
        payload.serialData.push({
          serialNumber: leftSerialNumber,
          side: 'left'
        });
      }
      if (!CheckUtils.isNullOrEmptyString(rightSerialNumber)) {
        payload.serialData.push({
          serialNumber: rightSerialNumber,
          side: 'right'
        });
      }
      return new Promise(function (resolve, reject) {
        axios.post('/api/shop/impression-file/impression-on-data', payload, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this26.token)).then(function (response) {
          if (response.status === 200) {
            var _response$data, _response$data2;
            response.data.leftSerialNumber = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.blnleftSerialNumber;
            response.data.rightSerialNumber = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.blnrightSerialNumber;
            resolve(response);
          } else {
            var reason = {
              response: response,
              message: response.statusText
            };
            reject(reason);
          }
        }).catch(function (err) {
          // connection error
          reject(err);
        });
      });
    }
  }]);
}();
export default ApiClientServiceOrder;